
<div class="dashboard-tx  flex flex-col sticky top-[90px] z-[2000] -translate-x-[15px] -translate-y-[24px] pt-3 pb-2 pl-[77px]  bg-white box"
    style="box-shadow:0 4px 2px -2px rgba(0, 0, 0, 0.2);width:calc(100% + 30px)">
    <p class="text-2xl font-medium mb-2.5 text-[#003366]">BÁO CÁO THỐNG KÊ PHIẾU TỬ VONG</p>
    <div class=" rounded-md mb-2 flex flex-row gap-3 dash">
        <form [formGroup]="stateForm">
            <mat-form-field class="small-form-field" appearance="outline">
                <mat-label>Tỉnh/thành phố</mat-label>
                <input type="text" matInput formControlName="vn_prov_d" [matAutocomplete]="autoGroup">
                <mat-autocomplete (optionSelected)="onOptionSelected($event)" #autoGroup="matAutocomplete">
                    <mat-optgroup *ngFor="let group of stateGroupOptions | async" [label]="group.letter">
                        <mat-option *ngFor="let name of group.names" [value]="name">
                            {{name}}
                        </mat-option>
                    </mat-optgroup>
                </mat-autocomplete>
            </mat-form-field>
        </form>
        <div class=" flex items-center gap-3  relative">
           
            <mat-form-field class="small-form-field dash1" appearance="outline">
                <mat-label>Ngày bắt đầu</mat-label>
                <input matInput [matDatepicker]="startPicker" placeholder="Chọn ngày bắt đầu"
                    (dateChange)="startDateChanged($event)">
                <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
                <mat-datepicker #startPicker></mat-datepicker>
            </mat-form-field>
            đến
            <mat-form-field class="small-form-field dash2" appearance="outline">
                <mat-label>Ngày kết thúc</mat-label>
                <input matInput [matDatepicker]="endPicker" placeholder="Chọn ngày kết thúc"
                    (dateChange)="endDateChanged($event)">
                <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
                <mat-datepicker #endPicker></mat-datepicker>
            </mat-form-field>

        </div>
        <button mat-raised-button (click)="reGenerate()" class="my-1 hover:opacity-95 text" color="primary">Thống
            kê</button>
    </div>
</div>
<div class="px-[60px] mt-[20px] mb-10 dashsing">
    <div class="grid  grid-cols-7 gap-4 ">
        <div class="rounded-md col-span-4 h-full flex flex-col gap-4 mobile-col-1">
            <div class="rounded-md border-c p-3 bg-white">
                <div class="flex mb-2.5 gap-4 flex-row w-full items-end">
                    <span
                        class="text-[45px] font-semibold block mb-2 text-black">{{tNum(textBoxData.total_death)}}</span>
                    <div class="flex flex-col gap-1 justify-between font-medium text-[16px] "
                        [ngClass]="textBoxData.asc === 1 ? 'text-[red]' : textBoxData.asc === 2 ?'text-[green]':'text-slate-500' ">
                        <div class="flex flex-row  items-center">
                            <svg *ngIf="textBoxData.asc === 1" width="20" height="20" viewBox="0 0 24 24" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M18.6806 13.9783L15.4706 10.7683L13.5106 8.79828C12.6806 7.96828 11.3306 7.96828 10.5006 8.79828L5.32056 13.9783C4.64056 14.6583 5.13056 15.8183 6.08056 15.8183H11.6906H17.9206C18.8806 15.8183 19.3606 14.6583 18.6806 13.9783Z"
                                    fill="currentColor" />
                            </svg>
                            <svg *ngIf="textBoxData.asc === 2" width="24" height="24" viewBox="0 0 24 24" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M17.9188 8.17969H11.6888H6.07877C5.11877 8.17969 4.63877 9.33969 5.31877 10.0197L10.4988 15.1997C11.3288 16.0297 12.6788 16.0297 13.5088 15.1997L15.4788 13.2297L18.6888 10.0197C19.3588 9.33969 18.8788 8.17969 17.9188 8.17969Z"
                                    fill="currentColor" />
                            </svg>

                            {{tNum(textBoxData.transform)}}
                        </div>
                        <div>{{ textBoxData.asc===1 ? 'Tăng' : textBoxData.asc===2?'Giảm':"Không đổi" }} trong vòng {{
                            textBoxData.day_gap >= 28 ? '28 ngày' : '24h' }} qua</div>
                    </div>

                </div>
                <p class="font-semibold  text-black text-[17px] mb-1">Báo cáo số lượng tử vong</p>
                <span class="text-black">{{getCity()}}, 28 ngày từ {{formatDate(this.endDate)}}</span>
            </div>
            <div class=" p-2 bg-white border-c rounded-md ">
                <div class="ml-2 my-2">
                    <mat-button-toggle-group class="tgBut" [(ngModel)]="dateType" (change)="onDateTypeChange($event)"
                        aria-label="date type">
                        <mat-button-toggle value="day" checked>Ngày</mat-button-toggle>
                        <mat-button-toggle value="month">Tháng</mat-button-toggle>
                        <mat-button-toggle value="year">Năm</mat-button-toggle>
                    </mat-button-toggle-group>
                </div>
                <div id="chart1"></div>
            </div>



        </div>
        <div class="flex flex-col h-full gap-4 col-span-3 mobile-col-1">

            <div class="p-2 rounded-md border-c bg-white">
                <div class=" overflow-y-auto h-[610px]">
                    <div class="ml-2 bg-white text-black pt-2 mb-3 text-[18px] font-bold  sticky top-0"
                        style="width:calc(100% - 25px)">
                        Số lượng người tử vong được ghi nhận bởi Bộ Y tế<br>
                        <span class="text-black font-normal mt-1 block text-[14px]">{{getCity()}}, từ
                            {{formatDate2(this.startDate,'s')}} đến {{formatDate2(this.endDate)}}</span>
                    </div>
                    <table mat-table class="ml-2" [dataSource]="dataSource">

                        <!-- Position Column -->
                        <ng-container matColumnDef="name">
                            <th mat-header-cell *matHeaderCellDef> Tỉnh </th>
                            <td mat-cell *matCellDef="let element"> {{element.name}} </td>
                        </ng-container>

                        <!-- Name Column -->
                        <ng-container matColumnDef="count">
                            <th mat-header-cell *matHeaderCellDef> Tổng số ca </th>
                            <td mat-cell *matCellDef="let element"> {{element.count}} </td>
                        </ng-container>

                        <!-- Weight Column -->
                        <ng-container matColumnDef="nam">
                            <th mat-header-cell *matHeaderCellDef> Nam </th>
                            <td mat-cell *matCellDef="let element"> {{element.nam}} </td>
                        </ng-container>

                        <!-- Symbol Column -->
                        <ng-container matColumnDef="nu">
                            <th mat-header-cell *matHeaderCellDef> Nữ </th>
                            <td mat-cell *matCellDef="let element"> {{element.nu}} </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

                        <tr mat-row *matRowDef="let row; let i = index; columns: displayedColumns;"
                            [ngClass]="{'first-row': i === 0 && getCity()===row.name}"></tr>

                    </table>
                    <mat-paginator class="sticky bottom-0 z-1" [length]="totalItems" [pageSize]="9"
                        (page)="onPageChange($event)" showFirstLastButtons></mat-paginator>
                </div>
            </div>

        </div>

    </div>
    <div class="grid grid-cols-2 mt-4 gap-4">
        <div class="col-span-1 ds1">
            <div class=" p-2 bg-white rounded-md border-c relative ">

                <div id="chart-vn"></div>
            </div>
        </div>
        <div class="col-span-1 flex flex-col gap-4 ds2">
            <div class=" p-2 bg-white rounded-md border-c ">

                <div id="chart-bubble" class="h-[450px]"></div>
            </div>
            <div class=" p-2 rounded-md bg-white border-c ">

                <div id="chart-nega" class="h-[388xp]"></div>
            </div>
        </div>
    </div>
    <div [ngClass]="{'h-[670px]': displayValue==='table'}" class="p-3 mt-4 rounded-md border-c grid-chart bg-white ">
        <div class="sticky top-[-16px] bg-white py-3 stic">
            <div class="ml-2 bg-white  mb-2 text-[18px] font-bold " style="width:calc(100% - 25px)">
                Thống kê tử vong theo mã bệnh<br>
                <span class="text-black font-normal mt-1 block text-[14px]">Tất cả các trường hợp tử vong đi sâu vào mã
                    bệnh
                    , Cả hai giới tính , mọi chủng tộc , mọi dân tộc</span>
            </div>

            <div class="mb-2 flex flex-row gap-3">
                <mat-form-field class="small-form-field  dash3" appearance="outline">
                    <mat-label>Hiển thị</mat-label>
                    <mat-select label placeholder="Chọn hiển thị" [(value)]="displayValue"
                        (selectionChange)="onDisplayChange($event)">
                        <mat-option value="grid">
                            Dạng lưới
                        </mat-option>
                        <mat-option value="table">
                            Dạng bảng
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field class="small-form-field dash4" appearance="outline">
                    <mat-label>Loại thống kê</mat-label>
                    <mat-select label placeholder="Chọn định dạng" [(value)]="displayValueType"
                        (selectionChange)="onDisplayValueTypeChange($event)">
                        <mat-option value="num">
                            Số lượng tử vong
                        </mat-option>
                        <mat-option value="per">
                            Tỷ lệ tử vong
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field class="small-form-field dash5" appearance="outline">
                    <mat-label>Loại mã</mat-label>
                    <mat-select label placeholder="Chọn mã theo" [(value)]="displayValueCode"
                        (selectionChange)="onDisplayValueCodeChange($event)">
                        <mat-option value="code4">
                            Mã đầy đủ (4 ký tự)
                        </mat-option>
                        <mat-option value="code3">
                            Gộp loại bệnh (3 ký tự)
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <table class="grid-d" *ngIf="dataGroup100 && displayValue==='grid'">
            <thead>
                <tr>
                    <th *ngFor="let ageGroup of dataGroup100[0]">{{ ageGroup.name }}</th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let row of dataGroup100; let i = index">
                    <tr *ngIf="i > 0">
                        <th>{{i}}</th>
                        <td class="text-center" *ngFor="let entry of row.slice(1); let index = index">
                            <div class="w-full">
                                <div
                                    class="bg-[#efefef] boxer rounded-md w-[65px] h-[65px] text-[12px]  flex flex-col items-center justify-center">
                                    <span>{{entry.name}}</span>
                                    <span class=" mt-1 font-bold" [innerHTML]="entry.value"></span>
                                </div>
                            </div>
                        </td>
                    </tr>
                </ng-container>
            </tbody>
        </table>
        <table class="mb-2" *ngIf="dataGroup100 && displayValue==='table'">
            <thead class="bg-[#efefef] h-[42px] sticky top-[120px]">
                <tr>
                    <th class="!font-semibold" *ngFor="let ageGroup of dataGroup100[0]">{{ ageGroup.name }}</th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let row of dataGroup100.slice(1); let i = index">
                    <tr class="h-[35px]" [ngClass]="{'bg-[#efefef]': i % 2 !== 0, 'bg-white': i % 2 === 0}">
                        <td class="text-center" *ngFor="let entry of row; let idx = index">
                            <div class="w-full" [ngClass]="{'font-medium': idx===0}">
                                <div>
                                    <span class="mt-1">{{entry.value}}</span>
                                </div>
                            </div>
                        </td>
                    </tr>
                </ng-container>
            </tbody>

        </table>

    </div>
    <div class="p-3 mt-4 rounded-md border-c bg-white">
        <div class="ml-2 bg-white  mb-2 text-[18px] font-bold text-black" style="width:calc(100% - 25px)">
            Tình hình tử vong<br>
            <span class=" text-black font-normal mt-1 block text-[14px] text"> Thống kê từ {{this.formatDateLine(
                this.startDate,
                's'
            )}} đến {{this.formatDateLine(this.endDate)}}</span>
        </div>

        <div class="flex gap-3 flex-row sea">
            <mat-form-field appearance="outline">
                <mat-label>Tỉnh/Thành phố</mat-label>
                <mat-select [formControl]="prov_name_s" multiple  (openedChange)="onOpenedChange1($event)"  (keydown)="onKeydownIP1($event)">

                    <mat-select-trigger>
                        {{provNameArray[0] || ''}}
                        <span *ngIf="provNameArray.length > 1" class="example-additional-selection">
                            (+{{provNameArray.length - 1}} {{provNameArray.length === 2 ? 'other' : 'others'}})
                        </span>
                    </mat-select-trigger>
                    <mat-option *ngFor="let prov of filteredProvName" [value]="prov">{{prov}}</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline">
                <mat-label>Cơ sở khám chữa bệnh</mat-label>
                <mat-select [formControl]="list_hos_s" multiple (openedChange)="onOpenedChange2($event)"  (keydown)="onKeydownIP2($event)">
                    <mat-select-trigger>
                        {{hosArray[0] || ''}}
                        <span *ngIf="hosArray.length > 1" class="example-additional-selection">
                            (+{{hosArray.length - 1}} {{hosArray.length === 2 ? 'other' : 'others'}})
                        </span>
                    </mat-select-trigger>
                    <mat-option *ngFor="let hos of filteredHos" [value]="hos">{{hos}}</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline">
                <mat-label>Mã bệnh</mat-label>
                <mat-select [formControl]="list_dis_s" multiple (openedChange)="onOpenedChange3($event)"  (keydown)="onKeydownIP3($event)">
                    <mat-select-trigger>
                        {{disArray[0] || ''}}
                        <span *ngIf="hosArray.length > 1" class="example-additional-selection">
                            (+{{disArray.length - 1}} {{disArray.length === 2 ? 'other' : 'others'}})
                        </span>
                    </mat-select-trigger>
                    <mat-option *ngFor="let dis of filteredDis" [value]="dis">{{dis}}</mat-option>
                </mat-select>
            </mat-form-field>
            <button mat-raised-button (click)="reSync()" class="my-1 hover:opacity-95" color="primary">Thống
                kê</button>
            
        </div>
        <div class="my-3">
            <mat-button-toggle-group class="tgBut"  [(ngModel)]="viewType" (change)="onViewTypeChange($event)"
                aria-label="view type">
                <mat-button-toggle value="1" checked>Tỉnh</mat-button-toggle>
                <mat-button-toggle value="2">Cơ sở y tế</mat-button-toggle>
                <mat-button-toggle value="3">Mã bệnh</mat-button-toggle>
            </mat-button-toggle-group>
        </div>
        <div id="boxChart__container" (mousemove)="addHighlight($event)" (touchmove)="addHighlight($event)"
            (touchstart)="addHighlight($event)" >

            
        </div>
    </div>


</div>